// extracted by mini-css-extract-plugin
export default {"journal-entries-main__title":"JournalEntries_journal-entries-main__title__+FIsX"};